import { render } from "./RegistrationConfirm.vue?vue&type=template&id=2bbfdb48"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Nomura\\PROJECT\\010.Src_By_SYSLAB\\007.MCSC_Web\\Git_main\\FrontEnd\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__